function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useState, createElement as _createElement } from 'react';
import cn from 'classnames';
import { subDays } from 'date-fns';
import { Button, Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AgreementHeader } from "./AgreementHeader";
import { StepPage } from "../../components/StepPage";
import { useResponsive } from "../../contexts";
import RecipientDetails from "../../../components/RecipientDetails/RecipientDetails";
import { useShallowStore, useStoreActions } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { relationshipModel } from "../../../models";
import { RelationshipStatus } from "../../../models/relationship";
import { fromDateStampObject } from "../../../models/time";
import { selectors } from "../../../store/state-selectors";
import { formatShortMonthUSDate } from "../../../utils";
import { replacePlaceholders } from "../../../utils/introductory-message.utils";
import { TextBox } from "../../components/TextBox";
import { COBStep, getStepName, getNextStepButtonText } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import { useCobStorage } from "../CobStorageContext";
import styles from "./WelcomeStep.module.scss";
import { getLimitedTimeDiscountOfferCalloutText, NEW_BUSINESS_NAME_FLAG, useWelcomeStepUtils } from "./welcomeStepUtils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  WelcomeStepTestIds
} = getTestIds();
const ExpirationDateCallout = _ref => {
  let {
    intent,
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Callout, {
    intent: intent,
    className: styles.expirationDateCallout,
    "data-testid": "expiration-date-message",
    children: children
  });
};
export default function WelcomeStep(_ref2) {
  var _selectedWorkspace$na, _relationship$buyer$f, _relationship$signato;
  let {
    onDone
  } = _ref2;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    isMobile
  } = useResponsive();
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    getFromStorage
  } = useCobStorage(relationship);
  const {
    createOrSelectBusiness,
    newBusinessWorkspace
  } = useWelcomeStepUtils({
    relationship
  });
  const [worksAt, workspaces] = useShallowStore(state => [selectors.user.business(state), selectors.user.workspaces(state)]);
  const {
    logBI
  } = useStoreActions();
  const hasAdditionalRecipients = relationshipModel.hasAdditionalRecipients(relationship);
  const getSelectedWorkspace = () => {
    const shouldUseRelationshipCustomer = relationship.isSample || isPreview;
    const isNewBusinessSelected = relationship.suggestedCustomerName && !(newBusinessWorkspace !== null && newBusinessWorkspace !== void 0 && newBusinessWorkspace.id) && getFromStorage('select_new_business') !== false;
    const newBusiness = {
      id: NEW_BUSINESS_NAME_FLAG,
      name: relationship.suggestedCustomerName
    };
    return shouldUseRelationshipCustomer ? relationship.customer : isNewBusinessSelected ? newBusiness : worksAt || (workspaces === null || workspaces === void 0 ? void 0 : workspaces[0].toIdAndName());
  };
  const getLimitedTimeDiscountOfferCallout = () => {
    const calloutText = getLimitedTimeDiscountOfferCalloutText(relationship);
    if (!calloutText) return null;
    return /*#__PURE__*/_jsx(Callout, {
      intent: "info",
      "data-testid": "limited-time-discount-offer-callout",
      withBorder: true,
      children: calloutText
    });
  };
  const [selectedWorkspace, setSelectedWorkspace] = useState(getSelectedWorkspace());
  useEffect(() => {
    setSelectedWorkspace(getSelectedWorkspace());
  }, [worksAt, relationship]);
  return /*#__PURE__*/_jsx(StepPage, {
    showDownloadAsPDFButton: true,
    disableDownloadAsPDFButton: isPreview,
    header: getStepName(COBStep.welcome, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS)),
    dataTestId: WelcomeStepTestIds.Root(),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      "data-testid": relationship.isSample ? WelcomeStepTestIds.TestAgreementPrimaryNextButton() : WelcomeStepTestIds.PrimaryNextButton(),
      onClick: () => {
        if (!isPreview) {
          logBI(10801);
        }
        if ((selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.id) === NEW_BUSINESS_NAME_FLAG) {
          createOrSelectBusiness(NEW_BUSINESS_NAME_FLAG);
        }
        onDone();
      },
      children: getNextStepButtonText(COBStep.welcome, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS))
    }),
    children: /*#__PURE__*/_jsxs(TextBox, {
      children: [relationship.expirationDate && (relationship.status === RelationshipStatus.Expired ? /*#__PURE__*/_jsx(ExpirationDateCallout, {
        intent: "warning",
        children: "This proposal expired on ".concat(formatShortMonthUSDate(fromDateStampObject(relationship.expirationDate)), ".")
      }) : /*#__PURE__*/_jsx(ExpirationDateCallout, {
        intent: "info",
        children: "Please note that this proposal is valid until ".concat(formatShortMonthUSDate(subDays(fromDateStampObject(relationship.expirationDate), 1)), ".")
      })), getLimitedTimeDiscountOfferCallout(), /*#__PURE__*/_jsx(AgreementHeader, {
        relationship: relationship,
        companyName: (_selectedWorkspace$na = selectedWorkspace === null || selectedWorkspace === void 0 ? void 0 : selectedWorkspace.name) !== null && _selectedWorkspace$na !== void 0 ? _selectedWorkspace$na : '',
        className: cn(styles.withHorizontalBorder, {
          [styles.mobile]: isMobile
        }),
        isPreview: isPreview
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "paragraph1",
        showWhiteSpaces: true,
        breakWords: true,
        className: cn(styles.coverLetter, {
          [styles.mobile]: isMobile
        }),
        children: replacePlaceholders(relationship.customNotificationText, (_relationship$buyer$f = relationship.buyer.firstName) !== null && _relationship$buyer$f !== void 0 ? _relationship$buyer$f : '', relationship.vendor.name)
      }), hasAdditionalRecipients && /*#__PURE__*/_jsxs("div", {
        "data-testid": "additional-recipients-section",
        className: styles.withHorizontalBorder,
        children: [/*#__PURE__*/_jsx(Typography, {
          weight: "normal",
          children: "Additional recipients"
        }), (_relationship$signato = relationship.signatories) === null || _relationship$signato === void 0 ? void 0 : _relationship$signato.map((signatory, index) => /*#__PURE__*/_createElement(RecipientDetails, _objectSpread(_objectSpread({}, signatory), {}, {
          key: signatory.id,
          badge: relationshipModel.hasSignatorySigned(relationship, signatory.id) ? 'signed' : 'required',
          testid: "welcome-step-signatory-".concat(index)
        }))), relationship.reviewers.map((reviewer, index) => /*#__PURE__*/_createElement(RecipientDetails, _objectSpread(_objectSpread({}, reviewer), {}, {
          key: reviewer.id,
          testid: "welcome-step-reviewer-".concat(index)
        })))]
      })]
    })
  });
}